import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {ProductPage} from './pages/ProductPage';

function App() {
    return (
        <HelmetProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Navigate to="/7-days-pass" replace/>}/>
                    <Route path="/:refId" element={<ProductPage/>}/>
                    <Route path="/:refId/success/:orderRefId" element={<ProductPage/>}/>
                    <Route path="/:refId/cancel" element={<ProductPage/>}/>
                </Routes>
            </Router>
        </HelmetProvider>
    );
}

export default App;
